import PaymentMethodCard from './PaymentMethodCard';

export default PaymentMethodCard;